import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { GlassCard } from "@/components/GlassCard";
import { Reveal, SectionKicker } from "@/components/Reveal";
import SEO from "@/components/SEO";
import { container, goldBtn } from "@/lib/constants";

const JOURNEY = [
  ["Apply for access", "Submit an application on behalf of your principal or vehicle. You will confirm your email and land on a holding page while the desk verifies your status."],
  ["Verification", "We verify principal standing and jurisdiction, typically within two business days. You will be notified the moment access is granted."],
  ["Complete your profile", "Once verified, complete KYC and submit your mandate — sectors, geographies, and ticket size — from your account."],
  ["Browse the deal board", "Explore curated, off-market opportunities. Restricted deals show a teaser until you request and are granted access."],
  ["Request access & accept the NDA", "For a restricted deal, request access. Once granted, accept the NDA to unlock the full detail and documents."],
  ["Request an introduction", "When there is genuine fit, request an introduction. The desk coordinates directly with the counterparty and supports you through diligence."],
];

export default function HowToUse() {
  return (
    <PublicLayout>
      <SEO title="How to use the desk" description="A guided walkthrough of the investor journey, from application to deal introduction." />
      <section className={`${container} py-20 lg:py-24`}>
        <Reveal>
          <SectionKicker>The investor journey</SectionKicker>
          <h1 className="pdg-serif text-4xl sm:text-5xl text-foreground max-w-3xl leading-[1.08]">How to use Prime Deal Gateway</h1>
          <p className="mt-6 text-lg text-foreground/80 max-w-2xl leading-8">
            From application to introduction — exactly what to expect at each step.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {JOURNEY.map(([t, d], i) => (
            <Reveal key={t} delay={(i % 2) * 0.05}>
              <GlassCard className="p-7 h-full">
                <div className="pdg-mono text-xs text-[hsl(var(--pdg-gold))]">STEP {String(i + 1).padStart(2, "0")}</div>
                <h2 className="mt-3 pdg-serif text-xl text-foreground">{t}</h2>
                <p className="mt-3 text-sm text-muted-foreground leading-7">{d}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
        <div className="mt-12">
          <Link to="/auth?tab=apply" className={goldBtn}>Begin your application</Link>
        </div>
      </section>
    </PublicLayout>
  );
}
